<template>
  <div class="mt-0">
    <v-data-iterator 
      v-if="!loading_employees"
      :items="current_execution.employees" 
      :items-per-page.sync="itemsPerPage" 
      hide-default-footer 
      :search="search"
    >
      <template v-slot:default="{items}">
        <v-row justify="center" v-if="items" class="pa-1">
          <v-col v-for="(item, item_idx) in items" :key="item_idx" class="ma-2" cols="11" md='10'>
            <employee-card :item="item" :item_idx='item_idx'></employee-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations} from 'vuex'
import EmployeeCard from './EmployeeCard.vue'

export default {
  components: { EmployeeCard },
  name: 'EmployeeTable',
  data() {
    return {
      search: null,
      itemsPerPage: -1,
      local_current_time: null,
      loading_employees: false,
      
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    }),
    ...mapMutations({
      setCurrentTime: 'Execution/setCurrentTime'
      // function: 'Module/action'
    })
  },
  mounted () {
    // this.setupAllTimes();
  },
  computed: {
    employees() {
      if (this.current_execution && this.current_execution.employees.length){
        return this.current_execution.employees.map(e=> ({name: e.name, local_ref: e.local_ref}))
      }
      return [] 
    },
    ...mapState({
      current_execution: state => state.Execution.current_execution,
      current_time: state => state.Execution.current_time,
      current_time_idx: state => state.Execution.current_time_idx,
      profile: state => state.User.profile,
      // data: state=> state.Module.state_var
    }),
  },
  watch: {
    current_time_idx(nv, ov) {
      if(nv){
      }
    },
    current_time(nv, ov) {
      if(nv){
      }
    },
  },

}
</script>

<style lang="scss" scoped>

</style>